export const IMG = (name) => `${process.env.PUBLIC_URL || ""}/assets/img/${name}.jpg`;

export const imgUrl = (img) => (!img ? "" : img.startsWith("/") ? img : IMG(img));

export const company = {
  name: "G. R. Engineering Private Limited",
  short: "G. R. Engineering",
  domain: "grengg.com",
  phone: "+91 22 2496 0551 ~ 55",
  phoneHref: "+912224960551",
  email: "sales@grengg.com",
  address: ["202/A Poonam Chambers", "Dr. Annie Besant Road, Worli", "Mumbai – 400 018, India"],
  people: [
    { name: "Mr. R. D. Hariani", role: "Chairman & Managing Director", img: "cmd-rd-hariani" },
    { name: "Mr. Gil Zigilbaur", role: "Executive Director", img: "gil-zigilbaur" },
  ],
};

export const stats = [
  { value: 1966, plain: true, label: "Year of Incorporation", sub: "Six decades of engineering" },
  { value: 1400, suffix: "+", label: "Projects Executed", sub: "Across India & abroad" },
  { value: 100, suffix: "+", label: "Satisfied Customers", sub: "Refineries to power plants" },
  { value: 113, suffix: "+", label: "Mounded Storage Vessels", sub: "1,00,000 MT storage installed" },
];

export const capabilities = [
  { title: "Heavy Fabrication", img: "hmel-loading", desc: "Large and super-heavy process equipment fabricated at Tarapur works and at site.", to: "/capabilities" },
  { title: "Pressure Vessels", img: "bcpl-fractionator", desc: "High-pressure vessels up to 425 MT single-piece, in CS, clad and alloy grades.", to: "/products" },
  { title: "Columns & Towers", img: "column-tall-hmel", desc: "Columns up to 6.8 m diameter and 110 m length, shop and site fabricated.", to: "/products" },
  { title: "Heat Exchangers", img: "exchanger-b", desc: "Shell & tube and Helixchanger® units in exotic metallurgies.", to: "/products" },
  { title: "Reactors & Regenerators", img: "reactor-heavy-lift", desc: "FCCU / PFCC reactor–regenerator packages on EPCC / LSTK basis.", to: "/products" },
  { title: "Mounded Storage Vessels", img: "mounded-vessels", desc: "113+ mounded bullets commissioned for LPG, propane and propylene.", to: "/products" },
  { title: "Horton Spheres", img: "sphere-c", desc: "Spheres for LPG, propylene and VCM storage on EPC basis.", to: "/products" },
  { title: "EPC / LSTK Projects", img: "opal-c4", desc: "Total project management from design to commissioning and handover.", to: "/services" },
];

export const scaleMetrics = [
  { group: "Shop-Fabricated Columns & Towers", items: [
    { value: "6.8 m", label: "Maximum Diameter" },
    { value: "110 m", label: "Maximum Length" },
    { value: "225 MT", label: "Single-Piece Weight" },
    { value: "102 mm", label: "Shell Thickness" },
  ]},
  { group: "Shop-Fabricated Pressure Vessels", items: [
    { value: "6.5 m", label: "Maximum Diameter" },
    { value: "35 m", label: "Maximum Length" },
    { value: "425 MT", label: "Single-Piece Weight" },
    { value: "125 mm", label: "Shell Thickness" },
  ]},
  { group: "Heat Exchangers — Executed", items: [
    { value: "430 mm", label: "Tube Sheet Thickness" },
    { value: "395 kg/cm²g", label: "Test Pressure" },
    { value: "2,100 mm", label: "Maximum Diameter" },
    { value: "4,100", label: "Number of Tubes" },
  ]},
  { group: "Site-Fabricated Super-Heavy — HMEL Bathinda", items: [
    { value: "2,230 MT", label: "Heaviest Single Column" },
    { value: "13 m", label: "Largest Internal Diameter" },
    { value: "103 m", label: "Longest Tower" },
    { value: "6 Nos.", label: "Towers at One Complex" },
  ]},
];

export const services = [
  { title: "Residual & Detailed Design", desc: "Complete mechanical design and engineering of pressure equipment and process plants.", icon: "DraftingCompass" },
  { title: "Procurement", desc: "Procurement of raw materials and bought-out components from approved global sources.", icon: "PackageSearch" },
  { title: "Material Management", desc: "Identification, traceability and control of materials across fabrication stages.", icon: "Boxes" },
  { title: "Installation & Erection", desc: "Heavy lifting, erection and installation of columns, vessels and structures at site.", icon: "Crane" },
  { title: "Pre-Commissioning", desc: "Mechanical completion, testing, flushing and pre-commissioning activities.", icon: "ClipboardCheck" },
  { title: "Commissioning", desc: "Commissioning, stabilization, performance guarantee test runs and plant handover.", icon: "Power" },
  { title: "Total Project Management", desc: "Complete project management for process plants on EPC / LSTK basis.", icon: "KanbanSquare" },
  { title: "Planning & Scheduling", desc: "Planning, scheduling and monitoring across engineering, procurement and construction.", icon: "GanttChart" },
  { title: "Construction Management", desc: "Construction management with skilled and experienced site teams.", icon: "HardHat" },
  { title: "Quality Assurance", desc: "QA/QC with in-house NDT, NABL-accredited mechanical testing and inspection.", icon: "ShieldCheck" },
];

export const products = [
  {
    id: "pressure-vessels",
    name: "High Pressure Vessels",
    img: "bcpl-fractionator",
    desc: "Shop-fabricated high-pressure vessels for refinery, petrochemical and process service — from HP storage drums and flare gas drums to crude de-salters — built to ASME Section VIII with 'U' & 'U2' stamps.",
    specs: [
      ["Maximum Diameter", "6.5 m"],
      ["Maximum Length", "35 m"],
      ["Shell Thickness", "Up to 125 mm"],
      ["Single-Piece Weight", "Up to 425 MT"],
    ],
    moc: "CS, Clad — SA 516 Gr 60/70, SA 516 Gr 60 (NACE + HIC), SA 387 Gr 11 / Gr 22 + 316L Clad",
    applications: "H₂ / HP storage, HC flare gas drums, compressor suction drums, condensate drums, slop drums, fuel gas separators, crude de-salters",
  },
  {
    id: "columns-towers",
    name: "Columns & Towers",
    img: "column-tall-hmel",
    desc: "Regenerators, main fractionators, absorbers, strippers and treaters — shop fabricated up to 110 m in length, and site-fabricated well beyond where road transport ends.",
    specs: [
      ["Maximum Diameter", "6.8 m"],
      ["Maximum Length", "110 m"],
      ["Shell Thickness", "Up to 102 mm"],
      ["Single-Piece Weight", "Up to 225 MT"],
    ],
    moc: "CS / LTCS, SS, LAS, Clad — SA 516 Gr 60/70, SA 537 Cl 1/2, SS 300 series, 347, 405, 410S, Duplex, SA 387 Gr 5 / Gr 11 Cl 1/2, 304L, 316L, 321",
    applications: "Regenerators, main fractionators, absorbers, de-butanisers, strippers, stage strippers, amine absorbers, xylene columns",
  },
  {
    id: "shell-tube-exchangers",
    name: "Shell & Tube Heat Exchangers",
    img: "exchanger-b",
    desc: "Fixed tube sheet, floating head and kettle-type exchangers engineered for severe refinery and petrochemical duties, including high test pressures and exotic tube materials.",
    specs: [
      ["Tube Sheet Thickness", "Up to 430 mm"],
      ["Test Pressure", "Up to 395 kg/cm² g"],
      ["Diameter", "Up to 2,100 mm"],
      ["Number of Tubes", "Up to 4,100"],
    ],
    moc: "Shell: CS / LTCS (incl. HIC), SS, Super Duplex, LAS, Inconel/Monel Clad, Titanium, Brass, Cu-Ni · Tube Sheet: CS, SS, LAS, Clad · Tubes: CS, SS, LAS, Titanium, Fin Tubes",
    applications: "Reboilers, condensers, aftercoolers, preheaters, quench and fractionator train exchangers",
  },
  {
    id: "helix-exchangers",
    name: "Helix Heat Exchangers",
    img: "exchanger-d",
    desc: "Helical baffle (Helixchanger®) exchangers supplied in quantity for mega petrochemical complexes — including 33 units for a single project at HMEL Bathinda.",
    specs: [
      ["Type", "Helical Baffle / Helixchanger®"],
      ["Executed Weights", "Up to 155 MT per unit"],
      ["Diameters", "Up to 2,928 mm ID"],
      ["Lengths", "Up to 16.8 m overall"],
    ],
    moc: "CS, SS, LAS and clad construction to project specifications",
    applications: "Quench oil / dilution steam preheaters & reboilers, quench water coolers, CGS aftercoolers, fractionator and refrigeration condensers",
  },
  {
    id: "reactors-regenerators",
    name: "Reactors & Regenerators",
    img: "rr-package-site",
    desc: "Complete reactor–regenerator (RR / RXRG) packages for FCCU and PFCC units, executed on EPCC / LSTK basis — residual design, detailed engineering, procurement, fabrication, erection, refractory and commissioning. Executed packages include HMEL Bathinda (commissioned 2012) and BPCL Kochi (commissioned 2017), with the NRL Numaligarh PFCC package in progress.",
    specs: [
      ["Reactor Diameter", "13,000 mm × 68,000 mm height"],
      ["Regenerator Diameter", "15,000 mm"],
      ["Total Fabrication", "1,200 MT per package"],
      ["Executed Packages", "HMEL Bathinda (2012) · BPCL Kochi (2017)"],
      ["Ongoing", "NRL Numaligarh PFCC (RXRG)"],
      ["MOC", "SA 516 Gr 70 & SA 387 Gr 11 Cl 1"],
    ],
    moc: "SA 516 Gr 70, SA 387 Gr 11 Cl 1 and project-specified alloy grades",
    applications: "FCCU / PFCC reactor–regenerator systems, polymerization reactors, guard beds, treaters",
  },
  {
    id: "mounded-storage",
    name: "Mounded Storage Bullets",
    img: "mounded-vessels",
    desc: "G. R. Engineering pioneered mounded storage in India — the first mounded LPG storage facility for GAIL in 1998 — and has since commissioned more than 113 storage vessels totalling 1,00,000 MT of capacity.",
    specs: [
      ["Vessels Commissioned", "113+"],
      ["Storage Capacity Installed", "1,00,000 MT"],
      ["Typical Size", "Up to 8.5 m ID × 80 m long"],
      ["Delivery Basis", "LSTK turnkey — civil, piping, E&I, cathodic protection"],
    ],
    moc: "Pressure vessel quality carbon steel to code and project specification",
    applications: "LPG, propane, propylene and butane storage for refineries, petrochemical plants and import terminals",
  },
  {
    id: "horton-spheres",
    name: "Horton Spheres",
    img: "sphere-c",
    desc: "Horton spheres supplied on EPC basis for storage and transfer of LPG, propane, propylene, butane and VCM across refineries, petrochemical complexes and nuclear plants in India and Sri Lanka.",
    specs: [
      ["Product Spheres", "Up to 552 MT each"],
      ["Check / Spec Spheres", "Up to 286 MT each"],
      ["Delivery Basis", "EPC — design, fabrication, erection"],
      ["Markets", "India & Sri Lanka"],
    ],
    moc: "Pressure vessel quality steels to code and client specification",
    applications: "LPG / propylene / VCM storage for refinery, petrochemical and nuclear installations",
  },
];

export const industries = [
  { name: "Oil & Gas", icon: "Fuel", desc: "Storage terminals, LPG facilities and process equipment" },
  { name: "Refineries", icon: "Factory", desc: "FCCU / PFCC packages, fractionators, columns and vessels" },
  { name: "Petrochemicals", icon: "FlaskConical", desc: "Ethylene plants, PVC / VCM complexes, C4 units" },
  { name: "Fertilizers", icon: "Sprout", desc: "Process plant construction on EPC / LSTK basis" },
  { name: "Chemical & Process", icon: "Atom", desc: "Super duplex and titanium equipment, bio-refinery packages" },
  { name: "Power & Nuclear", icon: "Zap", desc: "Horton spheres and equipment for nuclear installations" },
];

export const clients = ["IOCL", "BPCL", "HMEL", "ONGC – OPaL", "GAIL", "NRL", "BCPL", "Reliance (RCML)", "Adani – Mundra Petrochem", "Beximco", "Tata Projects", "tkIS"];

export const projects = [
  {
    id: "iocl-panipat-fractionator",
    client: "tkIS / IOCL",
    title: "Main Fractionator Column Package — Indmax Unit, Panipat Refinery Expansion (P-25)",
    location: "Panipat, Haryana",
    categories: ["Refinery", "Site Fabrication", "EPC / LSTK"],
    status: "Ongoing",
    scope: "Complete mechanical design & engineering, procurement, shop pre-fabrication, site fabrication with welded internals, NDT & heat treatment, hydrotest, painting, erection and mechanical completion.",
    specs: [["Tag No.", "412-C-2001"], ["Internal Diameter", "9,600 mm"], ["Length", "52 m"], ["Weight", "900 MT"]],
    img: "hero-panipat",
    featured: true,
  },
  {
    id: "hmel-site-fabricated",
    client: "HMEL",
    title: "Site-Fabricated Super-Heavy Columns — Guru Gobind Singh Refinery Complex",
    location: "Bathinda, Punjab",
    categories: ["Petrochemical", "Site Fabrication"],
    status: "Completed",
    scope: "Site fabrication of six super-heavy towers including propylene fractionators, gasoline fractionator, quench tower and ethylene fractionator.",
    specs: [["Propylene Fractionator No. 1", "8.7 m ID × 103 m — 2,230 MT"], ["Gasoline Fractionator", "13 m ID × 65 m — 1,784 MT"], ["Quench Tower", "12.3 m ID × 60.2 m — 1,650 MT"], ["Ethylene Fractionator", "6.2 m ID × 95 m — 1,077 MT"]],
    img: "site-fab-aerial",
    featured: true,
  },
  {
    id: "bpcl-kochi-rr",
    client: "BPCL",
    title: "Reactor–Regenerator (RR) Package — FCCU, Kochi Refinery",
    location: "Kochi, Kerala",
    categories: ["Refinery", "EPC / LSTK"],
    status: "Completed — Aug 2017",
    scope: "EPCC / LSTK execution of the FCCU reactor–regenerator package for the Integrated Refinery Expansion Project — detailed engineering, procurement, shop fabrication at Tarapur, site assembly on the permanent structure, refractory lining and large-diameter flue gas duct piping.",
    specs: [["Reactor", "13,000 mm dia × 68,000 mm height"], ["Regenerator", "15,000 mm dia"], ["Package Value", "₹399.75 Cr"], ["Technological Structure", "3,878 MT"], ["Mechanical Completion", "Jun 2017 — commissioned 25 Aug 2017"], ["Main Erection Crane", "Demag CC-8800-1 crawler (1,600 T)"], ["Safety Record", "2 million man-hours without lost-time accident"], ["PMC / Licensor", "EIL New Delhi / Technip Stone & Webster"]],
    img: "bpcl-night",
    featured: true,
  },
  {
    id: "hmel-rr-package",
    client: "HMEL",
    title: "Reactor–Regenerator Package — FCCU",
    location: "Bathinda, Punjab",
    categories: ["Refinery", "EPC / LSTK"],
    status: "Completed — Mar 2012",
    scope: "Residual design, detailed engineering, procurement and construction of the FCCU reactor–regenerator package for the Guru Gobind Singh Refinery — shop pre-fabrication of segments at Tarapur works, site assembly with welding, NDT, PWHT and hydrotesting, complete refractory lining and interconnecting flue gas duct piping.",
    specs: [["Reactor", "13,000 mm dia × 68,000 mm height"], ["Regenerator", "15,000 mm dia"], ["Total Fabrication", "1,200 MT"], ["Package Value", "₹240 Cr"], ["Technological Structure", "2,100 MT"], ["Mechanical Completion", "Jan 2012 — commissioned Mar 2012"], ["Main Erection Crane", "Demag CC-8800 crawler (1,250 T)"], ["PMC / Licensor", "EIL New Delhi / Shaw Stone & Webster"]],
    img: "rr-c",
    featured: false,
  },
  {
    id: "ccr-bpcl-kochi",
    client: "BPCL — Kochi Refinery",
    title: "CCR CycleMax III Package — M.S. Block, BS-VI Project",
    location: "Kochi, Kerala",
    categories: ["Refinery", "EPC / LSTK"],
    status: "Completed — Apr 2021",
    scope: "LSTK execution of the CCR (CycleMax III) package — overall project management, residual process design, HAZOP & 3D modelling, procurement, fabrication of equipment, piping and super-structure, complete civil, mechanical, electrical, instrumentation and fire-fighting works, pre-commissioning and commissioning assistance through handover.",
    specs: [["Delivery Basis", "LSTK"], ["Mechanical Completion", "March 2021"], ["Commissioned", "April 2021"], ["Execution", "Modular construction (space-constrained site)"]],
    img: "ccr-bpcl-kochi",
    featured: false,
  },
  {
    id: "opal-dahej-c4",
    client: "ONGC Petro additions Ltd. (OPaL)",
    title: "C4 Hydrogenation Unit — Complete EPC",
    location: "Dahej, Gujarat",
    categories: ["Petrochemical", "EPC / LSTK"],
    status: "Completed",
    scope: "Pre-engineering site survey, soil investigation, detailed engineering, complete supply and installation of equipment, piping, electrical & instrumentation, civil works, modularized structures, pre-commissioning, commissioning, PGTR and 3 months operational assistance.",
    specs: [["Delivery", "Complete EPC"], ["Includes", "Civil, E&I, modular structures"], ["Completion", "PGTR & plant handover"]],
    img: "opal-c4",
    featured: true,
  },
  {
    id: "hmel-shop-columns",
    client: "HMEL",
    title: "Shop-Fabricated Columns & Pressure Vessels",
    location: "Bathinda, Punjab",
    categories: ["Petrochemical"],
    status: "Completed",
    scope: "Manufacture and supply of heavy shop-fabricated columns and vessels for the petrochemical complex.",
    specs: [["HP Depropanizer", "4,700/3,900 ID × 43.5 m — 320 MT"], ["Ethylene Treater", "106 thk × 3,500 ID — 240 MT"], ["Purge Column", "7,200 ID × 32 m — 230 MT"], ["Dehexanizer Column", "2,000 ID × 68.5 m — 216 MT"]],
    img: "columns-hmel-a",
    featured: false,
  },
  {
    id: "hmel-helix",
    client: "HMEL",
    title: "Helical Baffle Heat Exchangers — 33 Nos.",
    location: "Bathinda, Punjab",
    categories: ["Petrochemical"],
    status: "Completed",
    scope: "Design and manufacture of 33 Helixchanger® units for the quench, CGS and fractionation trains.",
    specs: [["Quantity", "33 exchangers"], ["Heaviest Unit", "Propylene Refrigeration Condenser — 155 MT"], ["Largest Diameter", "2,928 mm ID"], ["Longest", "16.8 m overall"]],
    img: "exchanger-c",
    featured: false,
  },
  {
    id: "nrl-rxrg",
    client: "Numaligarh Refinery Ltd.",
    title: "Reactor & Regenerator (RXRG) Package — PFCC Unit",
    location: "Numaligarh, Assam",
    categories: ["Refinery", "EPC / LSTK"],
    status: "Ongoing",
    scope: "Supply of the reactor & regenerator package for the PFCC unit of the Numaligarh Refinery Expansion Project.",
    specs: [["Package", "RXRG — PFCC Unit"], ["Project", "NREP — Numaligarh Refinery Expansion"]],
    img: "rr-d",
    featured: true,
  },
  {
    id: "bcpl-site-fabrication",
    client: "BCPL (PMC: EIL)",
    title: "Site-Fabricated Equipment — 2,20,000 TPA Ethylene Plant",
    location: "Lepetkata, Assam",
    categories: ["Petrochemical", "Site Fabrication"],
    status: "Completed",
    scope: "Site fabrication of the quench tower, gasoline fractionator, purge column and polymerization reactor for the ethylene and LLDPE/HDPE plants.",
    specs: [["Quench Tower", "113-CC-103"], ["Gasoline Fractionator", "113-CC-101"], ["Polymerization Reactor", "117-RB-400"], ["Purge Column", "117-VV-440"]],
    img: "bcpl-fractionator",
    featured: false,
  },
  {
    id: "gail-mounded",
    client: "GAIL (India) Ltd.",
    title: "India's First Mounded LPG Storage Facility",
    location: "India",
    categories: ["Oil & Gas", "Storage", "EPC / LSTK"],
    status: "Completed — 1998",
    scope: "Fabrication and installation of 3 bullets of 7.2 m diameter × 80 m long in a single mound, including complete civil, piping, electrical / instrumentation and cathodic protection on LSTK turnkey basis.",
    specs: [["Capacity", "3 × 1,400 MT LPG"], ["Bullets", "7.2 m dia × 80 m — 3 Nos."], ["Milestone", "First of its kind in India"], ["Year", "1998"]],
    img: "mounded-a",
    featured: true,
  },
  {
    id: "beximco-mongla",
    client: "Beximco",
    title: "Mounded Storage Bullets — Cross-Border EPC",
    location: "Mongla, Bangladesh",
    categories: ["Storage", "EPC / LSTK"],
    status: "Completed",
    scope: "Total design & engineering, mechanical equipment & piping works, fire protection, electrical, instrumentation. Bullet sections fabricated at Budge Budge, Kolkata and dispatched by waterway to Bangladesh via direct RO-RO operation.",
    specs: [["Delivery", "Design to dispatch — turnkey"], ["Logistics", "Kolkata jetty → Mongla by waterway"]],
    img: "beximco",
    featured: false,
  },
  {
    id: "iocl-gujarat-bullets",
    client: "IOCL — Gujarat Refinery",
    title: "LPG & Propylene Mounded Bullets — J18 Project",
    location: "Vadodara, Gujarat",
    categories: ["Refinery", "Storage"],
    status: "Ongoing",
    scope: "RR package and other equipment for PRU & RFCC unit; LPG and propylene mounded storage bullets with allied facilities for the J18 project.",
    specs: [["LPG Mounded Bullets", "44 thk × 7,000 ID × 80 m — 4 Nos."], ["Propylene Mounded Bullets", "54 thk × 8,500 ID × 71 m — 4 Nos."]],
    img: "mounded-site",
    featured: true,
  },
  {
    id: "mundra-vcm-spheres",
    client: "Mundra Petrochem Ltd. (Adani)",
    title: "VCM Horton Spheres — 1 MMTPA Green PVC Project",
    location: "Mundra, Gujarat",
    categories: ["Petrochemical", "Storage"],
    status: "Ongoing",
    scope: "Supply of Horton spheres for VCM storage for the Green PVC project.",
    specs: [["VCM Product Spheres", "552 MT each — 2 Nos. (1,104 MT)"], ["VCM Check Spheres", "286 MT each — 4 Nos. (1,144 MT)"]],
    img: "spheres-farm",
    featured: false,
  },
  {
    id: "rcml-nagothane",
    client: "Reliance Chemicals & Materials Ltd.",
    title: "VCM Spheres — Reliance Vinyls Program",
    location: "Nagothane, Maharashtra",
    categories: ["Petrochemical", "Storage"],
    status: "Ongoing",
    scope: "Supply of VCM product spheres (3 Nos.) and VCM spec sphere (1 No.) for the Reliance Vinyls Program.",
    specs: [["VCM Product Spheres", "3 Nos."], ["VCM Spec Sphere", "1 No."]],
    img: "sphere-b",
    featured: false,
  },
  {
    id: "assam-bio-refinery",
    client: "Assam Bio Refinery",
    title: "Site-Fabricated Equipment — Bio Refinery Project",
    location: "Numaligarh, Assam",
    categories: ["Chemical", "Site Fabrication"],
    status: "Completed",
    scope: "Supply and erection of site-fabricated equipment in super duplex stainless steel and titanium.",
    specs: [["Blow Heat Accumulator", "SA 240 Type 2507 Super Duplex"], ["Blow Tank", "SB 265 Grade 2 Titanium"], ["Cellulose Storage Tank", "SA 240 Gr 316L"]],
    img: "hmel-erection",
    featured: false,
  },
];

export const ndtCapabilities = [
  "Radiography — separate enclosure",
  "X-Ray",
  "Gamma Ray (Cobalt 60, Ir-192)",
  "Ultrasonic Flaw Detection (UT)",
  "TOFD — Time-of-Flight Diffraction",
  "PAUT — Phased Array UT",
  "Magnetic Particle Testing (MT)",
  "Liquid / Dye Penetrant Testing (PT)",
  "Positive Material Identification (PMI)",
  "Ferrite Checking",
  "DFT Coating Thickness Measurement",
  "Pneumatic Testing",
  "Helium Leak Detection",
  "Hydrostatic Testing up to 500 kg/cm² g",
];

export const mechanicalTests = [
  ["Tensile Testing", "In-house NABL-accredited laboratory"],
  ["Impact Testing", "Down to −195 °C"],
  ["Bend Testing", "Weld & parent material qualification"],
  ["Shear Bond Testing", "Clad bond integrity"],
  ["Hardness Testing", "Including HAZ and weld zones"],
];

export const bays = [
  { bay: "Bay A — Light Fabrication", size: "22 m wide × 140 m long" },
  { bay: "Bay B — Machining", size: "20 m wide × 140 m long" },
  { bay: "Bay C — Heavy Fabrication", size: "27 m wide × 160 m long" },
];

export const tarapurFunctions = [
  "Manufacturing", "QA / QC", "Production", "Welding Technology & NDT",
  "Planning", "Design", "Procurement", "Project Management", "Sales & Marketing",
];

export const milestones = [
  { year: "1966", text: "G. R. Engineering Private Limited incorporated — beginning of six decades in heavy engineering and fabrication." },
  { year: "1998", text: "First company in India to fabricate and install a mounded LPG storage facility — 3 × 1,400 MT in a single mound for GAIL, on LSTK turnkey basis." },
  { year: "Today", text: "ASME 'U' & 'U2' stamp holder executing mega-scale EPC / LSTK packages — site-fabricated towers up to 2,230 MT — for India's leading refineries and petrochemical complexes." },
];

export const philosophy = [
  "Quality workmanship on every weld and every document",
  "On-time delivery, managed by highly skilled and experienced staff",
  "Competitive costs through continually improved internal processes",
  "Our people are our biggest assets in fulfilling commitments to clients",
];

export const epcFlow = [
  "Residual & Detailed Design", "Procurement", "Material Management", "Fabrication",
  "Heat Treatment & NDT", "Testing & Inspection", "Dispatch / Jetty Load-out",
  "Erection & Installation", "Pre-Commissioning", "Commissioning & Handover",
];

export const projectFilters = ["All", "Refinery", "Petrochemical", "Oil & Gas", "Chemical", "EPC / LSTK", "Site Fabrication", "Storage"];

export const projectDetails = {
  "iocl-panipat-fractionator": {
    scopeList: [
      "Complete mechanical design & engineering",
      "Procurement of all raw materials and bought-out components",
      "Pre-fabrication of column at shop",
      "Fabrication of column at site including welded internals",
      "NDT & heat treatment, inspection & testing, hydrotest",
      "Surface preparation, primer & finish painting",
      "Mandatory & commissioning spares",
      "Erection of column, mechanical completion & handing over to tkIS / IOCL",
    ],
    equipment: [
      ["Main Fractionator Column", "Tag No. 412-C-2001 (867-E-10) — Indmax Unit, Panipat Refinery Expansion Project (P-25)", "ID 9,600 mm × 52 m long — 900 MT"],
    ],
  },
  "hmel-site-fabricated": {
    scopeList: [
      "Site fabrication of six super-heavy towers for the Guru Gobind Singh Refinery complex",
      "Full welding, NDT, heat treatment and testing executed at site",
    ],
    equipment: [
      ["Propylene Fractionator No. 1", "Tag 911-CC-4101 (829-E-50)", "8.7 m ID × 103 m — 2,230 MT · SA 516 Gr 70"],
      ["Propylene Fractionator No. 2", "Tag 911-CC-4102 (829-E-60)", "7.8 m ID × 62.7 m — 1,200 MT · SA 516 Gr 70"],
      ["Gasoline Fractionator", "Tag 911-CC-1201 (829-E-10)", "13 m ID × 65 m — 1,784 MT · SA 516 Gr 70"],
      ["Quench Tower", "Tag 911-CC-1301 (829-E-20)", "12.3 m ID × 60.2 m — 1,650 MT · SA 516 Gr 70"],
      ["Ethylene Fractionator", "Tag 911-CC-4002 (829-E-40)", "6.2 m ID × 95 m — 1,077 MT · SA 516 Gr 60"],
      ["Caustic Water Wash Tower", "Tag 911-CC-2101 (829-E-30)", "6.7 m ID × 66 m — 940 MT · SA 516 Gr 60"],
    ],
  },
  "bpcl-kochi-rr": {
    scopeList: [
      "Residual design and in-house detailed engineering of static equipment",
      "Procurement of all major bought-outs — EIL inspection (indigenous) and LRQA third-party inspection for U & R stamp activities",
      "Complete fabrication and testing at Tarapur shop: orifice chamber, external riser, internal mushroom riser, fresh & spent catalyst storage hoppers, fines hopper, CS & SS flue gas duct spools",
      "Pre-fabrication of Reactor, Regenerator and TSS segments at Tarapur works under LRQA inspection",
      "Assembly of segments, welding, NDT, PWHT and hydrotest at Kochi site on the permanent structure",
      "Refractory lining of Reactor, Regenerator, Orifice Chamber and TSS at Kochi site",
      "CS large-diameter (38\"–129\") refractory-lined flue gas duct piping — 290 m with 26 mitre bends; SS heavy 124\"/86\"/72\" FGD piping — 90 m",
      "Technological structure — 3,878 MT; heavy lifts with Demag CC-8800-1 (1,600 T) crawler crane",
      "Certified by BPCL Kochi Refinery for 2 million man-hours without any lost-time accident",
    ],
    equipment: [
      ["Reactor", "FCCU — U & R Stamp", "13,000 mm dia × 68,000 mm height · SA 516 Gr 70 & SA 387 Gr 11 Cl 1"],
      ["Regenerator", "FCCU — U & R Stamp", "15,000 mm dia · SA 516 Gr 70 & SA 387 Gr 11 Cl 1"],
      ["Third Stage Separator (TSS)", "U & R Stamp", "Shop fabricated"],
      ["Fresh & Spent Catalyst Storage Hoppers, Fines Hopper", "—", "Shop fabricated at Tarapur"],
      ["Technological Structure", "—", "3,878 MT"],
    ],
  },
  "hmel-rr-package": {
    scopeList: [
      "Residual design and in-house detailed engineering of static equipment",
      "Detailed engineering and 3D modelling of the technological structure",
      "Procurement of all major bought-outs by in-house purchase department — EIL inspection (indigenous) and LRQA third-party inspection for U & R stamp activities",
      "Pre-fabrication (pressing & rolling) of Reactor, Regenerator and TSS segments at Tarapur works under LRQA inspection",
      "Assembly of segments, welding, NDT, PWHT and hydrotest at Bathinda site on temporary foundations built by G. R. Engineering",
      "Complete refractory lining of Reactor, Regenerator, Orifice Chamber and TSS at site",
      "CS large-diameter (30\"–129\") refractory-lined flue gas duct piping — 240 m with 18 mitre bends",
      "Technological structure fabrication and erection — 2,100 MT",
      "Heavy erection lifts with Demag CC-8800 (1,250 T) crawler crane",
    ],
    equipment: [
      ["Reactor", "FCCU — U & R Stamp", "13,000 mm dia × 68,000 mm height · SA 516 Gr 70 & SA 387 Gr 11 Cl 1"],
      ["Regenerator", "FCCU — U & R Stamp", "15,000 mm dia · SA 516 Gr 70 & SA 387 Gr 11 Cl 1"],
      ["Third Stage Separator (TSS)", "U & R Stamp, incl. internals", "Site fabricated"],
      ["Orifice Chamber & Internal/Mushroom Risers", "LAS construction", "Shop fabricated at Tarapur"],
      ["Technological Structure", "—", "2,100 MT fabricated & erected"],
      ["Total Fabrication", "—", "1,200 MT"],
    ],
  },
  "ccr-bpcl-kochi": {
    scopeList: [
      "Overall project management for the CCR package",
      "Residual process design and detailed engineering including HAZOP & 3D modelling",
      "Procurement of all bought-out items and supply of all tagged and non-tagged materials",
      "Fabrication of equipment, piping and super-structure",
      "Complete civil, mechanical, electrical, instrumentation and fire-fighting works",
      "Trial runs and performance guarantee support",
      "Pre-commissioning and commissioning assistance for handing over the unit to BPCL",
    ],
    equipment: [
      ["CCR CycleMax III Unit", "M.S. Block, BS-VI Project", "Mechanical completion Mar 2021 — commissioned Apr 2021, successfully under operation"],
    ],
  },
  "opal-dahej-c4": {
    scopeList: [
      "Pre-engineering site survey, soil investigation & GRP ground mapping",
      "Detailed engineering",
      "Complete supply and installation of all equipment, piping, electrical, instrumentation and bulk materials",
      "Complete supply of all civil materials and execution of civil works",
      "Supply of modularized structure; welding and erection of structures",
      "Hiring of suitable cranes for installation of equipment, piping and structures",
      "Statutory certifications, inspection and testing",
      "Painting, insulation, pre-commissioning, commissioning and stabilization & PGTR",
      "Plant handover and 3 months operational assistance",
    ],
    equipment: [
      ["C4 Hydrogenation Unit", "Complete EPC", "Design to PGTR and handover"],
    ],
  },
  "hmel-shop-columns": {
    scopeList: ["Manufacture and supply of shop-fabricated columns and vessels for the petrochemical complex at Bathinda."],
    equipment: [
      ["HP Depropanizer", "—", "56/64/84 thk × 4,700/3,900 ID × 43.5 m — 320 MT"],
      ["Ethylene Treater", "—", "106 thk × 3,500 ID × 24.11 m — 240 MT"],
      ["Purge Column", "—", "36 thk × 7,200 ID × 32.08 m — 230 MT"],
      ["Dehexanizer Column", "—", "65/70/85 thk × 2,000 ID × 68.49 m — 216 MT"],
      ["Demethanizer Column", "—", "24/28 thk × 2,400/3,600/4,800 ID × 69.15 m — 195 MT"],
      ["Chloride Guard Bed", "—", "103 thk × 3,400 ID × 19.91 m — 185 MT"],
      ["ROG Depropanizer", "—", "40/48 thk × 2,400/4,100 ID × 41.7 m — 182 MT"],
      ["LP Depropanizer", "—", "36/24 thk × 3,000/3,600 ID × 51.78 m — 155 MT"],
      ["Reactor Dump Tank", "—", "43 thk × 4,300 ID × 28.55 m — 151 MT"],
      ["ROG Demethanizer Column", "—", "18/28 thk × 3,400/2,500 ID × 45.75 m — 100 MT"],
      ["Dethanizer Column", "—", "26 thk × 1,900 ID × 46.37 m — 75 MT"],
      ["HP Nitrogen Surge Tank", "—", "68 thk × 2,500 ID × 9.53 m — 45 MT"],
    ],
  },
  "hmel-helix": {
    scopeList: ["Design and manufacture of 33 helical baffle (Helixchanger®) heat exchangers for the quench, cracked gas and fractionation trains."],
    equipment: [
      ["Propylene Refrigeration Condenser", "—", "28 thk × 2,500 ID × 16.66 m — 155 MT"],
      ["Propylene Fractionator Condenser", "—", "25 thk × 2,200 ID × 16.82 m — 122 MT"],
      ["Quench Water Cooler No. 1", "—", "24 thk × 2,250 ID × 15.92 m — 120 MT"],
      ["Quench Oil / Dilution Steam Reboiler", "—", "18 thk × 2,100 ID × 13.04 m — 96 MT"],
      ["Quench Water Cooler No. 2", "—", "14 thk × 2,350 ID × 12.21 m — 96 MT"],
      ["CGS First Stage Aftercooler", "—", "14 thk × 2,928 ID × 11.95 m — 82 MT"],
      ["CGS Second Stage Aftercooler", "—", "18 thk × 1,800 ID × 11.88 m — 60 MT"],
      ["Rerun Tower Condenser", "—", "14 thk × 1,850 ID × 11.64 m — 56 MT"],
      ["Quench Oil / Dilution Steam Drum Preheater", "—", "14 thk × 1,370 ID × 14.76 m — 55 MT"],
      ["CGS Third Stage Aftercooler No. 1", "—", "24 thk × 1,500 ID × 11.5 m — 46 MT"],
    ],
  },
  "nrl-rxrg": {
    scopeList: ["Supply of the reactor & regenerator (RXRG) package for the PFCC unit of the Numaligarh Refinery Expansion Project."],
    equipment: [
      ["Reactor & Regenerator Package", "PFCC Unit", "RXRG package — Numaligarh Refinery Expansion Project"],
    ],
  },
  "bcpl-site-fabrication": {
    scopeList: [
      "Site fabrication of critical equipment for the 2,20,000 TPA ethylene plant and LLDPE/HDPE units (PMC: EIL, New Delhi)",
      "P.O. 6907-113-CC-PR-6405 / 6907-117-RA-PR-6000 — EIL Job No. 6907",
    ],
    equipment: [
      ["Quench Tower", "113-CC-103 (WO 684-E-20)", "Site fabricated"],
      ["Gasoline Fractionator", "113-CC-101 (WO 684-E-10)", "Site fabricated"],
      ["Purge Column", "117-VV-440 (WO 684-E-10)", "Site fabricated"],
      ["Polymerization Reactor", "117-RB-400 (WO 685-E-10)", "Site fabricated — LLDPE/HDPE, Lepetkata"],
    ],
  },
  "gail-mounded": {
    scopeList: [
      "Fabrication & erection of 3 bullets of 7.2 m diameter × 80 m long in a single mound",
      "Complete civil, piping, electrical / instrumentation and cathodic protection on LSTK turnkey basis",
      "First mounded LPG storage facility of its kind in India",
    ],
    equipment: [
      ["Mounded LPG Bullets", "3 Nos. in a single mound", "7.2 m dia × 80 m long — 3 × 1,400 MT LPG"],
    ],
  },
  "beximco-mongla": {
    scopeList: [
      "Total design & engineering",
      "Mechanical equipment & piping works",
      "Fire protection system",
      "Electrical works, instrumentation & fire screen works",
      "Fabrication of bullet sections at Budge Budge, Kolkata",
      "Dispatch of bullet sections from Kolkata jetty to Bangladesh by waterway (direct RO-RO)",
    ],
    equipment: [
      ["Mounded Storage Bullets", "Mongla, Bangladesh", "Bullet sections fabricated at Budge Budge, Kolkata — dispatched by sea"],
    ],
  },
  "iocl-gujarat-bullets": {
    scopeList: [
      "RR package and other equipment for PRU & RFCC unit",
      "LPG and propylene mounded storage bullets with allied facilities for the J18 project",
    ],
    equipment: [
      ["LPG Mounded Bullets", "4 Nos.", "44 thk shell × 7,000 ID × 80 m overall"],
      ["Propylene Mounded Bullets", "4 Nos.", "54 thk shell × 8,500 ID × 71 m overall"],
    ],
  },
  "mundra-vcm-spheres": {
    scopeList: ["Supply of Horton spheres for VCM storage for the 1 MMTPA Green PVC project."],
    equipment: [
      ["VCM Product Spheres", "Tag A01-S-0001A-B — 2 Nos.", "552 MT each (1,104 MT total)"],
      ["VCM Check Spheres", "Tag A01-S-0002A/B & A01-S-0003A/B — 4 Nos.", "286 MT each (1,144 MT total)"],
    ],
  },
  "rcml-nagothane": {
    scopeList: ["Supply of VCM spheres for the Reliance Vinyls Program, Nagothane."],
    equipment: [
      ["VCM Product Spheres", "3 Nos.", "Reliance Vinyls Program"],
      ["VCM Spec Sphere", "1 No.", "Reliance Vinyls Program"],
    ],
  },
  "assam-bio-refinery": {
    scopeList: ["Supply & erection of site-fabricated equipment in super duplex stainless steel and titanium for the Numaligarh bio refinery."],
    equipment: [
      ["Blow Heat Accumulator", "110-VV-0002", "SA 240 Type 2507 (UNS S32750) Super Duplex"],
      ["Blow Tank", "110-VV-003", "SB 265 Grade 2 (UNS R50400) Titanium"],
      ["Cellulose Storage Tank", "115-TT-0016", "SA 240 Gr 316L"],
    ],
  },
};
